<!-- Modal de Férias -->
<div
  *ngIf="personName"
  class="modal fade"
  id="vacationsModal"
  tabindex="-1"
  aria-labelledby="vacationsModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header">
        <div class="header-content">
          <div class="header-info">
            <h2 class="modal-title">Férias</h2>
            <div class="employee-info">
              <div class="employee-details">
                <span class="employee-name">{{ personName }}</span>
                <span class="employee-role">Funcionário</span>
              </div>
            </div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
      </div>
      <div class="modal-body">
        <div class="summary-info">
          <p class="summary-text">Histórico de férias registradas</p>
          <div class="stats-container">
            <div class="stat-item">
              <span class="stat-number">{{ vacations.length }}</span>
              <span class="stat-label">Total de Férias</span>
            </div>
          </div>
        </div>

        <!-- Tabela de Férias - Mostra apenas quando há férias -->
        <div class="mt-md-0 mt-sm-4 vacation-modal" *ngIf="vacations.length > 0">
          <mat-table [dataSource]="vacations">
            <!-- Coluna Descrição -->
            <ng-container matColumnDef="description">
              <mat-header-cell *matHeaderCellDef>Descrição</mat-header-cell>
              <mat-cell *matCellDef="let vacation">{{ vacation.description }}</mat-cell>
            </ng-container>

            <!-- Coluna Data de Início -->
            <ng-container matColumnDef="startDate">
              <mat-header-cell *matHeaderCellDef>Início</mat-header-cell>
              <mat-cell *matCellDef="let vacation">{{ formatDate(vacation.startDate) }}</mat-cell>
            </ng-container>

            <!-- Coluna Data de Fim -->
            <ng-container matColumnDef="endDate">
              <mat-header-cell *matHeaderCellDef>Fim</mat-header-cell>
              <mat-cell *matCellDef="let vacation">{{ formatDate(vacation.endDate) }}</mat-cell>
            </ng-container>

            <!-- Coluna Ações -->
            <ng-container matColumnDef="actions">
              <mat-header-cell *matHeaderCellDef>Ações</mat-header-cell>
              <mat-cell *matCellDef="let vacation">
                <div class="action-buttons">
                  <button
                    mat-icon-button
                    color="primary"
                    (click)="onEdit(vacation)"
                    matTooltip="Editar férias"
                    class="action-edit">
                    <mat-icon>edit</mat-icon>
                  </button>
                  <button
                    mat-icon-button
                    color="warn"
                    (click)="onDelete(vacation.id!)"
                    matTooltip="Excluir férias"
                    class="action-delete">
                    <mat-icon>delete</mat-icon>
                  </button>
                </div>
              </mat-cell>
            </ng-container>

            <!-- Linha do cabeçalho -->
            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <!-- Linhas dos dados -->
            <mat-row *matRowDef="let vacation; columns: displayedColumns;"></mat-row>
          </mat-table>
        </div>

        <!-- Estado Vazio Melhorado -->
        <div class="empty-state-container" *ngIf="vacations.length == 0">
          <div class="empty-state-content">
            <div class="empty-icon-wrapper">
              <mat-icon class="empty-icon">beach_access</mat-icon>
            </div>
            <h3 class="empty-title">Nenhuma férias cadastrada</h3>
            <p class="empty-description">
              Não há férias registradas para este funcionário.
              <br>
              Clique no botão "Cadastrar" para adicionar o primeiro registro de férias.
            </p>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button 
          type="button" 
          class="btn btn-outline-secondary" 
          data-bs-dismiss="modal">
          Fechar
        </button>
        <button 
          type="button" 
          class="btn btn-primary" 
          data-bs-toggle="modal" 
          (click)="onCreate()">
          Cadastrar
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Modal de Criação/Edição de Férias -->
<div
  *ngIf="personName"
  class="modal fade"
  id="vacationsCreateModal"
  tabindex="-1"
  aria-labelledby="vacationsCreateModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <div class="header-content">
          <div class="header-info">
            <h2 class="modal-title">Cadastrar Férias</h2>
            <div class="employee-info">
              <div class="employee-details">
                <span class="employee-name">{{ personName }}</span>
                <span class="employee-role">Funcionário</span>
              </div>
            </div>
          </div>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
      </div>
      <div class="modal-body">
        <div class="summary-info">
          <p class="summary-text">Preencha os dados das férias</p>
        </div>

        <form [formGroup]="formVacation" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-md-6 mb-3">
              <label for="vacationStartDate" class="form-label">Data de Início</label>
              <input type="date" class="form-control" id="vacationStartDate" formControlName="startDate" />
            </div>
            <div class="col-md-6 mb-3">
              <label for="vacationEndDate" class="form-label">Data de Fim</label>
              <input type="date" class="form-control" id="vacationEndDate" formControlName="endDate" />
            </div>
            <div class="mb-3">
              <label for="description" class="form-label">Observação</label>
              <textarea
                class="form-control"
                id="description"
                rows="5"
                formControlName="description"
                placeholder="Digite a observação"
              ></textarea>
              <div *ngIf="vacationDescription?.errors?.maxlength">
                Máximo de letras excedido! Por favor, o limite de letras é de {{ maxLength }}.
              </div>
              <div>Letras restantes: {{ remainingCharacters }}</div>
            </div>
          </div>
          <button
            *ngIf="!isSaving"
            [disabled]="formVacation.invalid"
            type="submit"
            class="btn btn-primary w-100"
          >
            Salvar
          </button>
        </form>
        <div *ngIf="isSaving" class="spinner-container">
          <div class="spinner"></div>
        </div>
      </div>
    </div>
  </div>
</div>
